import { jsxs as n, Fragment as N, jsx as k } from "react/jsx-runtime";
import { useState as S, useRef as H, useEffect as R } from "react";
import { TourTooltip as j } from "./components/TourTooltip.js";
import { TourOverlay as q } from "./components/TourOverlay.js";
/* empty css                                       */const D = ({
  steps: e,
  handleCloseAction: l,
  handleFinishAction: c,
  genericTaggingEvent: t
}) => {
  const [s, x] = S(0), [y, b] = S({ top: 0 }), u = H(null), m = `Step ${s + 1}`;
  R(() => {
    const o = e[s], r = document.querySelector(o.selector);
    let p;
    if (r && u.current) {
      const z = r.getBoundingClientRect(), P = u.current.offsetHeight, _ = 12;
      p = {
        zIndex: r.style.zIndex,
        background: r.style.background
      }, r.style.zIndex = "9999", r.style.background = "white";
      const d = z.top + window.scrollY - P - _;
      b({
        top: d
      }), window.scrollTo({
        top: d,
        behavior: "smooth"
      });
    }
    return () => {
      r && (r.style.zIndex = p.zIndex, r.style.background = p.background);
    };
  }, [s, e, u]);
  const f = (o) => {
    t == null || t("tour_closed", {
      clickedText: o,
      name: m
    }), l == null || l(), c == null || c();
  }, I = () => {
    t == null || t("tour_click_next", {
      clickedText: "Próximo",
      name: m
    }), x((o) => o < e.length - 1 ? o + 1 : o);
  }, w = () => {
    t == null || t("tour_click_prev", {
      clickedText: "Anterior",
      name: m
    }), x((o) => o > 0 ? o - 1 : o);
  };
  return e.length === 0 ? null : /* @__PURE__ */ n(N, { children: [
    /* @__PURE__ */ k(
      j,
      {
        ref: u,
        step: e[s],
        position: y,
        onClose: f,
        onPrevious: w,
        onNext: I,
        totalSteps: e.length,
        stepNumber: s + 1
      }
    ),
    /* @__PURE__ */ k(q, { stepNumber: s + 1, onClick: f })
  ] });
};
export {
  D as Tour
};
